import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ObjectSerializer";
import { MemesLeaderboardDrop } from "@/components/memes/drops/MemesLeaderboardDrop";
import { useWave } from "@/hooks/useWave";
import { DefaultWaveLeaderboardDrop } from "./DefaultWaveLeaderboardDrop";
interface WaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onSourceDropDeleted?: (() => void) | undefined;
}
export const WaveLeaderboardDrop: React.FC<WaveLeaderboardDropProps> = t0 => {
  const $ = _c(8);
  const {
    drop,
    wave,
    onDropClick,
    onSourceDropDeleted
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t1;
    if ($[0] !== drop || $[1] !== onDropClick || $[2] !== onSourceDropDeleted || $[3] !== wave) {
      t1 = <MemesLeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} onSourceDropDeleted={onSourceDropDeleted} />;
      $[0] = drop;
      $[1] = onDropClick;
      $[2] = onSourceDropDeleted;
      $[3] = wave;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== drop || $[6] !== onDropClick) {
    t1 = <DefaultWaveLeaderboardDrop drop={drop} onDropClick={onDropClick} />;
    $[5] = drop;
    $[6] = onDropClick;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};